import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { UpgradePreValidateToVersionDialogData } from '@app/shared/components/dialogs/upgrade-prevalidate-to-version-dialog/upgrade-prevalidate-to-version-dialog.data';

@Component({
    selector : 'upgrade-prevalidate-to-version-dialog',
    template: require('./upgrade-prevalidate-to-version-dialog.component.html'),
    styles: [require('./upgrade-prevalidate-to-version-dialog.component.scss')]
})
export class UpgradePreValidateToVersionDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: UpgradePreValidateToVersionDialogData) {
        data.autoBackupSelected = data.autoBackUpItems[0].Key;
        data.autoRestoreSelected = data.autoRestoreItems[0].Key;
    }

    public hasAdhocPackages() {
        const packagesAdhoc = this.data.versions.filter(p => p.isAdhocPackage);
        return packagesAdhoc.length > 0;
    }

    public adhocPackages() {
        return this.data.versions.filter(p => p.isAdhocPackage)
            .sort((a, b) =>  b.id - a.id);
    }

    public packages() {
        return this.data.versions.filter(p => !p.isAdhocPackage)
            .sort((a, b) => b.id - a.id);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/upgrade-prevalidate-to-version-dialog/upgrade-prevalidate-to-version-dialog.component.ts